import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { takeReturn, clearReturn } from "@/lib/returnPath";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { clearReturn(); navigate("/login"); return; }
    const sessionId = match[1];
    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id: sessionId });
        loginWithToken(res.data.session_token, res.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        // New accounts finish onboarding first; Onboarding then consumes the remembered return path.
        navigate(res.data.needs_onboarding ? "/onboarding" : (takeReturn() || "/dashboard"), { replace: true });
      } catch {
        clearReturn();
        setError(true);
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-ink border-t-coral rounded-full animate-spin mx-auto" />
        <p className="font-cabinet font-bold mt-4">{error ? "Sign-in failed, redirecting…" : "Signing you in…"}</p>
      </div>
    </div>
  );
}
